import $ from 'jquery';
import Widget from './Widget';
import Registry from '../Registry';
import {InvalidArgumentException} from '../Exceptions';

export default class AgendaWidget extends Widget {

    constructor(args){
        Registry.d("AgendaWidget.constructor");
        super(args);
        this.widget_link = `${Registry.widget_link}/${this.accountid}/agenda`;
        if (!args.container) { throw new InvalidArgumentException("Missing container"); }
        this.container = args.container;
        if (!args.widgetid && !args.ereg) { throw new InvalidArgumentException("Missing widgetid"); }
        this.containerid = (Math.random() + "").replace(".", "");
        $(this.container).attr("data-containerid", this.containerid);
        if (!this.width) { this.width = "100%"; }
        if (!this.height) { this.height = "100%"; }
        if (!this.language) { this.language = "eng"; }
        if (!this.mode) { this.mode = 3; }
        if(!this.websiteid) {this.websiteid = 0;}
    }

    createFrame(url = false){
        Registry.d("AgendaWidget.createFrame");
        $(`iframe[data-containerid='${this.containerid}']`).remove();
        let { width } = this;
        let src = url ? `src='${url}'` : "";
        return $(this.container).html(` 
            <iframe ${src} style='border: 0;' width='${width}' 
                data-containerid='${this.containerid}' scrolling="no" title="Agenda Widget Content"></iframe>
        `);
    }

    getUrl() {
        return `${Registry.baseURL}/${this.widget_link}/${this.widgetid}/${this.mode}/${this.language}/${this.websiteid}`;
    }

    display() {
        Registry.d("AgendaWidget.display");
        if (this.container) {
            this.createFrame();
            let dfd = $.Deferred();
            $.ajax({
                url: this.getUrl(),
                type: "get",
                dataType: "html",
                success: (res) => {
                    // if were using an iframe stick the new content inside of it then resize the iframe
                    this.iframe = $(`iframe[data-containerid='${this.containerid}']`);
                    if (this.iframe.length > 0) {
                        this.iframe[0].contentWindow.document.open();
                        this.iframe[0].contentWindow.document.write(res);
                        this.iframe[0].contentWindow.document.close();
                    }
                    $(this.container).removeClass('loading');
                    Registry.autoAdjust();
                    setTimeout(() => {
                        this.notify("widget_container", this.containerid);
                        this.notify("widget_language", this.language);
                    }, 1);
                    dfd.resolve(res);
                },
                error: (res) => {
                    dfd.reject(res);
                    return console.error(`status: ${res.status}: ${res.statusText}`);
                }
            });
            return dfd;
        }
    }
}






// WEBPACK FOOTER //
// ./src/embed/widgets/AgendaWidget.es6